import { createAsyncThunk } from '@reduxjs/toolkit'
import apiClient from '../../../services/axois'
import { toast } from 'react-toastify'
import { setTimeLeft } from '../../slice/exam/exam.slice'
import { UI_CONSTANT } from '../../../utility/constants'

export const getStudentProfile = createAsyncThunk('student/get-student-profile', async (studentId) => {
  try {
    const response = await apiClient.get(`/student/${studentId}`)

    return response.data.result
  } catch (error) {
    console.error('builder function error:', error)
  }
})

export const editStudentAcademicDetails = createAsyncThunk(
  'student/edit-student-profile',
  async ({ values, studentIdData: studentId, setOpenEditModal, dispatch }) => {
    try {
      const response = await apiClient.put(`/student/${studentId}/profile`, {
        academicDetails: values.academicDetails,
      })
      setOpenEditModal(false)
      dispatch(getStudentProfile(studentId))
      toast.success(response.data.message, {
        className: 'custom-toast-success',
        progressStyle: { background: '#ffffff' },
      })
    } catch (error) {
      console.error('builder function error:', error)
    }
  },
)

export const getStudentCourseDetails = createAsyncThunk('student/get-student-course', async (studentId) => {
  try {
    const response = await apiClient.get(`/student/course/${studentId}`)
    return response.data.result
  } catch (error) {
    console.error('builder function error:', error)
  }
})

export const getStudentPaymentDetails = createAsyncThunk('student/get-student-payment-details', async (studentId) => {
  try {
    const response = await apiClient.get(`/student/payment-history/${studentId}`)

    if (response?.data?.result[0]?.installmentNo !== 'Full payment') {
      let findFirstNullRecord = response?.data?.result
        ?.sort((a, b) => a?.installmentNo - b?.installmentNo)
        ?.find((i) => !i.paymentOn)
      const data = response?.data?.result
        ?.sort((a, b) => a.installmentNo - b.installmentNo)
        .map((item) => {
          return {
            ...item,
            disabled: findFirstNullRecord?.studentPaymentId === item?.studentPaymentId ? false : true,
          }
        })

      return data
    } else {
      return response?.data?.result || []
    }
  } catch (error) {
    console.error('builder function error:', error)
  }
})

export const handleStudentPayment = createAsyncThunk(
  'student/student-payment',
  async ({ studentPaymentId, studentId, feesAmount, dispatch }) => {
    try {
      const response = await apiClient.post('/student/create/orderId', {
        studentPaymentId,
        studentId,
      })
      if (response.status) {
        const orderId = response.data.result.orderId

        const options = {
          key: process.env.REACT_APP_RZP_KEY_ID,
          amount: feesAmount * 100,
          currency: 'INR',
          name: UI_CONSTANT.RAZORPAY_TITLE,
          order_id: orderId,
          handler: async function (response) {
            try {
              const paymentData = {
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id,
                razorpay_signature: response.razorpay_signature,
                paymentOn: new Date().toISOString(),
              }
              const result = await apiClient.post('/student/payment-callback', paymentData)
              dispatch(getStudentPaymentDetails(studentId))
              toast.success(result.data.message, {
                className: 'custom-toast-success',
                progressStyle: { background: '#ffffff' },
              })
            } catch (error) {
              console.error('Payment failed:', error)
              toast.error(error.response.data.message, {
                className: 'custom-toast-error',
                progressStyle: { background: '#C53C43' },
              })
            }
          },
          notes: {
            address: 'Razorpay Corporate Office',
          },
          theme: {
            color: '#ee4e56',
          },
        }

        if (window.Razorpay) {
          const rzp1 = new window.Razorpay(options)
          rzp1.on('payment.failed', function (response) {
            console.error(response.error)
            // alert(response.error.description)
            toast.error(response.error.data.message, {
              className: 'custom-toast-error',
              progressStyle: { background: '#C53C43' },
            })
          })
          rzp1.open()
        }
      }
    } catch (error) {
      console.error('Error creating order or handling payment:', error)
      toast.error(error.response.data.message, {
        className: 'custom-toast-error',
        progressStyle: { background: '#C53C43' },
      })
    }
  },
)

export const studentStartExam = createAsyncThunk(
  'student/exam-list',
  async ({ studentId, timetableId, startTime }) => {
    try {
      const url = `/student/exam-list/${timetableId}/${studentId}`
      const payload = {
        startTime,
      }
      const response = await apiClient.post(url, payload)
      return response.data.result
    } catch (error) {
      console.error('builder function error:', error)
      throw error
    }
  },
)

export const postExamAnswer = createAsyncThunk(
  'student/online-exam/postAnswers',
  async ({ studentOnlineExamPaperId, data }, { dispatch }) => {
    try {
      const url = `/student/online-exam/${studentOnlineExamPaperId}`
      const response = await apiClient.post(url, data)
      dispatch(setTimeLeft(response.data.result?.remainingTime))
      return response.data.result
    } catch (error) {
      console.error('builder function error:', error)
      throw error
    }
  },
)

export const publishExamResult = createAsyncThunk(
  'student/online-exam/publish-exam',
  async ({ timetableId, studentId }) => {
    try {
      const url = `/publish-result`
      const response = await apiClient.post(url, {
        timetableId,
        studentId,
      })

      if (response.status) {
        toast.success(response.data.message, {
          className: 'custom-toast-success',
          progressStyle: { background: '#ffffff' },
        })
      }
    } catch (error) {
      toast.error(error.response.data.message, {
        className: 'custom-toast-error',
        // progressStyle: { background: '#C53C43' },
      })
      console.error('builder function error:', error)

      throw error
    }
  },
)

export const setEndExam = createAsyncThunk('student/online-exam/end-exam', async ({ timetableId, endExam }) => {
  try {
    const url = `/end-exam`
    const response = await apiClient.post(url, {
      timetableId,
      endExam,
    })
    if (response.status) {
      toast.success(response.data.message, {
        className: 'custom-toast-success',
        progressStyle: { background: '#ffffff' },
      })
    }
  } catch (error) {
    toast.error(error.response.data.message, {
      className: 'custom-toast-error',
      // progressStyle: { background: '#C53C43' },
    })
    console.error('builder function error:', error)

    throw error
  }
})
